import { Component } from 'preact'
import Button from '@insided/control/uikit/Button'
// eslint-disable-next-line import/no-internal-modules
import { StateAwareHeaderComponentProps } from '@insided/deprecated-control/overview'
import CreateSegmentModal from './CreateSegmentModal'

export type SegmentOverviewHeaderActionsComponentProps = StateAwareHeaderComponentProps<{}>

interface State {
  showCreateModal: boolean
}

class SegmentOverviewHeaderActionsComponent extends Component<SegmentOverviewHeaderActionsComponentProps, State> {
  constructor(props: SegmentOverviewHeaderActionsComponentProps) {
    super(props)

    this.state = {
      showCreateModal: false
    }
  }

  showCreateModal = () => this.setState({ showCreateModal: true })

  hideCreateModal = () => this.setState({ showCreateModal: false })

  render() {
    const { showCreateModal } = this.state

    return (
      <div>
        <Button
          onClick={this.showCreateModal}
          title='Create new segment'
          variant='primary'
          size='medium'
        />
        <CreateSegmentModal
          onClose={this.hideCreateModal}
          showModal={showCreateModal}
        />
      </div>
    )
  }
}

export default SegmentOverviewHeaderActionsComponent
